import React, { useEffect, useState } from 'react';
import axiosInstance from '../api/axiosInstance';
import './AdminCommon.css';

const DashboardPage: React.FC = () => {
  const [stats, setStats] = useState<any>({
    userCount: 0,
    contentCount: 0,
    boardCount: 0,
    todayUserCount: 0,
    todayContentCount: 0
  });

  useEffect(() => {
    axiosInstance.get('/api/admin/stats', { 
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } 
    }).then(res => {
      setStats(res.data);
    }).catch(err => {
      console.error('통계 데이터 로딩 실패:', err);
    });
  }, []);

  return (
    <div className="admin-page-wrapper">
      <div className="admin-page-header">
        <div>
          <h2 className="admin-page-title">통계 대시보드</h2>
          <div className="admin-page-subtitle">역사 아카이브 서비스의 활동 통계 현황을 실시간으로 확인합니다.</div>
        </div>
      </div>

      <div className="stat-card-grid">
        {/* 전체 회원 수 */}
        <div className="stat-card">
          <div className="stat-icon-wrapper">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
          </div>
          <div className="stat-info">
            <span className="stat-label">전체 회원 수</span>
            <span className="stat-value">{stats.userCount?.toLocaleString() || 0} 명</span>
          </div>
        </div>

        {/* 전체 컨텐츠 수 */}
        <div className="stat-card stat-success">
          <div className="stat-icon-wrapper">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
              <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
            </svg>
          </div>
          <div className="stat-info">
            <span className="stat-label">전체 컨텐츠 수</span>
            <span className="stat-value">{stats.contentCount?.toLocaleString() || 0} 개</span>
          </div>
        </div>

        {/* 전체 게시글 수 */}
        <div className="stat-card stat-warning">
          <div className="stat-icon-wrapper">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
            </svg>
          </div>
          <div className="stat-info">
            <span className="stat-label">전체 게시글 수</span>
            <span className="stat-value">{stats.boardCount?.toLocaleString() || 0} 개</span>
          </div>
        </div>

        {/* 오늘 신규 가입 */}
        <div className="stat-card stat-success">
          <div className="stat-icon-wrapper">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <line x1="19" y1="8" x2="19" y2="14"></line>
              <line x1="16" y1="11" x2="22" y2="11"></line>
            </svg>
          </div>
          <div className="stat-info">
            <span className="stat-label">오늘 신규 가입</span>
            <span className="stat-value">{stats.todayUserCount?.toLocaleString() || 0} 명</span>
          </div>
        </div>

        {/* 오늘 등록 컨텐츠 */}
        <div className="stat-card stat-danger">
          <div className="stat-icon-wrapper">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 20h9"></path>
              <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
            </svg>
          </div>
          <div className="stat-info">
            <span className="stat-label">오늘 등록 컨텐츠</span>
            <span className="stat-value">{stats.todayContentCount?.toLocaleString() || 0} 개</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;
